var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTutorialTopArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 55,
    viewBox: "0 0 10 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0241631 9.16368C0.694976 5.80961 2.41993 2.93469 4.5282 0.347114C5.00751 -0.22787 5.96581 -0.036052 6.34913 0.538931C8.07408 3.60551 9.51154 6.95958 9.89486 10.5051C9.99069 11.5593 8.36157 11.6553 8.16991 10.697C7.4991 8.10954 6.54079 5.61779 5.295 3.22219C4.81584 3.893 4.33653 4.65964 3.95321 5.42629C4.62403 4.75547 6.15747 5.04297 6.15747 6.28876C6.25331 21.9091 9.79904 38.0085 7.01995 53.4374C6.82829 54.6832 4.72002 54.3957 4.81585 53.1499C6.06164 37.4337 3.66572 22.0051 3.56989 6.28876C3.56989 6.19293 3.56989 6.0971 3.56989 6.0971C2.99491 7.24707 2.61174 8.39703 2.3241 9.73866C2.13228 11.2719 -0.263329 10.697 0.0241631 9.16368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorialTopArrowWhite);
export default __webpack_public_path__ + "static/media/ic_tutorial_top_arrow_white.2230c66645b75ae770f947b3bb8e4eef.svg";
export { ForwardRef as ReactComponent };